import { useContext } from 'react';
import GlobalLocaleContext from '../../GlobalLocale/GlobalLocaleContext';
import { Icon } from '@ellucian/ds-icons/lib';

const BackArrow = props => {
    const { localeDirection } = useContext(GlobalLocaleContext);
   
    return (
        <Icon name={localeDirection === 'rtl' ? 'arrow-right' : 'arrow-left'}  {...props}/>
    );
};

export default BackArrow;
